import React, { FunctionComponent, useState } from 'react'; 
import { Container, Row, Col,  Modal, Button } from 'react-bootstrap';


const PageBlank:FunctionComponent<{}> = () => {
  return(
    <Container>
      <div className="container-fluid">
	<div className="row">
    
		<div className="col-md-12">
      
		</div>
	</div>
</div>
    </Container>
  );
}

export default PageBlank;